import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: () => import("../containers/MainContainer"),
        children: [
            {
                path: "/home",
                name: "home",
                component: () => import("../views/Home"),
            },
            {
                path: "/",
                name: "",
                component: () => import("../views/Home"),
            },

            {
                path: "/profile",
                name: "profile",
                component: () => import("../views/Profile.vue"),
            },

            {
                path: "/mainItems",
                name: "mainItems",
                component: () => import("../views/Admin/MainItems.vue"),
            },
            {
                path: "/subItems",
                name: "subItems",
                component: () => import("../views/Admin/SubItems.vue"),
            },
            {
                path: "/users",
                name: "users",
                component: () => import("../views/UserPanel/Users.vue"),
            },
            {
                path: "/dailyReports",
                name: "dailyReports",
                component: () => import("../views/UserPanel/DailyReports.vue"),
            },{
                path: "/approvalDailyReports",
                name: "approvalDailyReports",
                component: () => import("../views/UserPanel/ApprovalDailyReports.vue"),
            },
            {
                path: "/sell",
                name: "sell",
                component: () => import("../views/UserPanel/Sell.vue"),
            },
            {
                path: "/selectCustomer",
                name: "selectCustomer",
                component: () => import("../views/UserPanel/SelectCustomer.vue"),
            },
            {
                path: "/inquiris",
                name: "inquiris",
                component: () => import("../views/UserPanel/Inquiris.vue"),
            },
            {
                path: "/supplierInquiris",
                name: "supplierInquiris",
                component: () => import("../views/UserPanel/SupplierInquiris.vue"),
            },
            {
                path: "/decide",
                name: "decide",
                component: () => import("../views/UserPanel/Decide.vue"),
            },
            {
                path: "/pickWinner",
                name: "pickWinner",
                component: () => import("../views/UserPanel/PickWinner.vue"),
            },
            {
                path: "/recordInquiry",
                name: "recordInquiry",
                component: () => import("../views/UserPanel/RecordInquiry.vue"),
            },
            {
                path: "/clarification",
                name: "clarification",
                component: () => import("../views/UserPanel/Clarification.vue"),
            },
            {
                path: "/nonacceptance",
                name: "nonacceptance",
                component: () => import("../views/UserPanel/Nonacceptance.vue"),
            },
            {
                path: "/inquiryFollowUp",
                name: "inquiryFollowUp",
                component: () => import("../views/UserPanel/InquiryFollowUp.vue"),
            },
            {
                path: "/product",
                name: "product",
                component: () => import("../views/UserPanel/Product.vue"),
            },
            {
                path: "/unit",
                name: "unit",
                component: () => import("../views/UserPanel/Unit.vue"),
            },
            {
                path: "/category",
                name: "category",
                component: () => import("../views/UserPanel/Category.vue"),
            },
            {
                path: "/suppliers",
                name: "suppliers",
                component: () => import("../views/UserPanel/Suppliers.vue"),
            },
            {
                path: "/customers",
                name: "customers",
                component: () => import("../views/UserPanel/Customers.vue"),
            },
            {
                path: "/titleWorks",
                name: "titleWorks",
                component: () => import("../views/UserPanel/TitleWorks.vue"),
            },
            {
                path: "/fCalendar",
                name: "fCalendar",
                component: () => import("../views/UserPanel/FCalendar.vue"),
            },
            {
                path: "/causes",
                name: "causes",
                component: () => import("../views/UserPanel/Causes.vue"),
            },
            {
                path: "/categoryToSupplier",
                name: "categoryToSupplier",
                component: () => import("../views/UserPanel/CategoryToSupplier.vue"),
            },
            {
                path: "/customerBuy",
                name: "customerBuy",
                component: () => import("../views/UserPanel/CustomerBuy.vue"),
            },

            {
                path: "/recipts",
                name: "recipts",
                component: () => import("../views/UserPanel/Recipts.vue"),
            },
            {
                path: "/customerFollow",
                name: "customerFollow",
                component: () => import("../views/UserPanel/CustomerFollow.vue"),
            },
            {
                path: "/comapyPayment",
                name: "comapyPayment",
                component: () => import("../views/UserPanel/ComapyPayment.vue"),
            },
            {
                path: "/check",
                name: "check",
                component: () => import("../views/UserPanel/Check.vue"),
            },
            {
                path: "/userWallet",
                name: "userWallet",
                component: () => import("../views/UserWallet.vue"),
            },
            {
                path: "/payReciptFor",
                name: "payReciptFor",
                component: () => import("../views/UserPanel/PayReciptFor.vue"),
            },
            {
                path: "/percents",
                name: "percents",
                component: () => import("../views/UserPanel/Percents.vue"),
            },
            {
                path: "/benefit",
                name: "benefit",
                component: () => import("../views/UserPanel/Benefit.vue"),
            },
            {
                path: "/benefitByCustomerBuy",
                name: "benefitByCustomerBuy",
                component: () => import("../views/UserPanel/BenefitByCustomerBuy.vue"),
            },


        ],
    },
    // adminContainer
    {
        path: "/admin",
        component: () => import("../containers/AdminContainer"),
        children: [
            {
                path: "/login",
                name: "login",
                component: () => import("../views/Login.vue"),
            },
        ],
    },

    // webContainer - no container

    // {
    //     path: "/",
    //     component: () => import("../containers/WebContainer"),
    //     children: [
    //         {
    //             path: "/",
    //             name: "",
    //             component: () => import("../views/SitePage.vue"),
    //         },
    //
    //         {
    //             path: "/mainpage",
    //             name: "mainpage",
    //             component: () => import("../views/WebView/Mainpage.vue"),
    //         },
    //     ],
    // },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
